// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/**
  * UpdateTitle - Updates the page title
  *
  * @example
    <UpdateTitle />
  *
  * @param {string} title - Required. The title of the webpage.
  *
  * @version 0.0.1
  * @todo none
  */
var UpdateTitle = function UpdateTitle(props) {
  return React.createElement(Helmet, { title: props.title });
};

UpdateTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string
} : {};

UpdateTitle.defaultProps = {
  title: "Webpage"
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Export
// ----------------------------------------------------------------------------
export default UpdateTitle;